import React from "react";
import truncate from "lodash-es/truncate";
import { I18nUtil, formatRelativeTime } from "@utils";
import Translations from "@translate/components/kolStatus/FollowInfo";

const I18n = I18nUtil.createScoped(Translations);

export interface FollowInfoProps {
  type?: string;
  timeStamp?: number;
  handle?: string;
  postId?: string;
  screenName?: string;
}

const typeMap = {
  mention: "Posted by",
  follow: "Followed by",
} as const;

const getTwitterUrl = (screenName: string, postId?: string) => {
  return postId
    ? `https://x.com/${screenName}/status/${postId}`
    : `https://x.com/${screenName}`;
};

export const FollowInfo: React.FC<FollowInfoProps> = ({
  type,
  timeStamp,
  handle,
  screenName,
  postId,
}) => {
  const onClick = () => {
    if (!screenName) {
      return;
    }

    const twitterUrl = getTwitterUrl(
      screenName,
      type === "mention" ? postId : undefined,
    );
    window.open(twitterUrl, "twitter", "noopener,noreferrer");
  };

  return (
    <p className="z-10 body_s text-content_tertiary !-tracking-[0.5px] whitespace-nowrap overflow-hidden text-ellipsis gap-[6px]">
      <span>
        {I18n.t("%{var0} by", {
          var0: typeMap[type as keyof typeof typeMap],
        })}
      </span>
      <span
        data-openreplay-label={`kolStatus · FollowInfo · span | @{truncate(handle || screenName || "", { length: 11 })}`}
        className="body_medium_s text-content_primary cursor-pointer ml-1"
        onClick={onClick}
      >
        @{truncate(handle || screenName || "", { length: 11 })}
      </span>
      <span className="mx-[6px] w-[3px] h-[3px] rounded-full inline-block bg-content_tertiary mb-[3px]" />
      <span>{formatRelativeTime(timeStamp)}</span>
    </p>
  );
};
